import { t } from "@/i18n-js/instance";
import { EditorCollapsable } from "@circle-react-shared/BuilderUI/Editor/EditorCollapsable";
import { useEmailCustomColors } from "@circle-react-shared/Emails/VisualEmailBuilder/Themes/hooks/useEmailCustomColors";
import { Form } from "@circle-react-uikit/Form";
import { generateFormItemName } from "./Styles";

const labelClassName = "!font-normal text-xs";

export const Background = () => {
  const {
    flattenedCssVariables,
    themeColors,
    customColors,
    handleAddCustomColor,
  } = useEmailCustomColors();

  return (
    <EditorCollapsable
      title={t("builder_ui.prop_type.styles.background")}
      defaultOpen
    >
      <div className="px-6 py-5">
        <Form.Item
          name={generateFormItemName("backgroundColor")}
          label={t(
            "settings.emails.visual_builder.prop_type.styles.background_color",
          )}
          hideDescription
          hideBorder
          className="!flex !w-full !items-center !justify-between !p-0"
          labelClassName={labelClassName}
        >
          <Form.ColorPickerV2
            name={generateFormItemName("backgroundColor")}
            cssVariables={flattenedCssVariables}
            shouldResolveCssVariable
            shouldRenderThemeColors
            shouldShowAlpha={false}
            themeColors={themeColors}
            customColors={customColors}
            onAddCustomColor={handleAddCustomColor}
          />
        </Form.Item>
      </div>
    </EditorCollapsable>
  );
};
